import { createSelector } from "reselect";
import { populationTalliesSelector } from "../population_tallies_by_etiology_selector";

export const populationTalliesDataSelector = createSelector(
  populationTalliesSelector,
  tallies => {
    return tallies.data;
  }
);
